/**
 * Model registry.
 *
 * Every model here must be licensed for commercial use. Two common choices are
 * deliberately EXCLUDED:
 *   - ISNet / isnet-general-use : AGPL-3.0, copyleft, unsafe for a commercial
 *     web app even though most tutorials reach for it.
 *   - briaai/RMBG-1.4 and 2.0   : free tier is non-commercial only; shipping it
 *     in a paid product needs a licence agreement from BRIA.
 */
export const MODELS = {
    /** Free tier. Vendored into public/models so there is no third-party fetch. */
    u2netp: {
        id: 'u2netp',
        label: 'Fast',
        url: '/bg-remover/models/u2netp/onnx/model.onnx',
        inputSize: 320,
        mean: [0.485, 0.456, 0.406],
        std: [0.229, 0.224, 0.225],
        // Confirmed by scanning the graph: the input tensor is literally "input.1".
        inputName: 'input.1',
        // Outputs are named "1959".."1965"; "1959" is the fused prediction.
        outputName: '1959',
        needsSigmoid: false,
        letterbox: true,
        sizeLabel: '4.4 MB',
        licence: 'Apache-2.0',
        source: 'BritishWerewolf/U-2-Netp',
    },
    /**
     * HD tier. 115 MB, so it is NOT vendored -- it would blow up the repo and
     * exceeds Cloudflare Pages' 25 MB per-file limit.
     *
     * Before launch: copy this file to your own R2 bucket (no file-size limit,
     * zero egress fees) and replace the URL below. Until then it streams from
     * Hugging Face's CDN, which is the one remaining third-party dependency.
     */
    birefnet: {
        id: 'birefnet',
        label: 'HD',
        url: 'https://huggingface.co/onnx-community/BiRefNet_lite-ONNX/resolve/main/onnx/model_fp16.onnx',
        inputSize: 1024,
        mean: [0.485, 0.456, 0.406],
        std: [0.229, 0.224, 0.225],
        inputName: 'input_image',
        outputName: 'output_image',
        needsSigmoid: true,
        letterbox: false,
        sizeLabel: '115 MB',
        licence: 'MIT',
        source: 'onnx-community/BiRefNet_lite-ONNX',
    },
};
